/**
 * Reads the new leads form id from a create API response.
 *
 * @param {object|undefined|null} response Axios response
 * @returns {string|null}
 */
export function extractCreatedFormId(response) {
  const payload = response?.data?.data ?? response?.data;
  if (payload == null) {
    return null;
  }

  if (typeof payload === 'object' && payload.leads_form_id != null) {
    return String(payload.leads_form_id);
  }

  return null;
}
